import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './card.scss';

const Card = match => {
  const {
    title,
    titleValue,
    subtitle,
    children,
    className,
    secondTitle,
    secondTitleValue,
    isCollapsed
  } = match;

  const [collapse, setCollapse] = useState(isCollapsed);

  return (
    <div className={'cardBlock ' + className}>
      <div className="cardBlockHeader">
        <h2 className="cardBlockTitle">
          {title}
          <span className="cardBlockTitleSecondary">{titleValue}</span>
        </h2>
        {subtitle && (
          <span className="cardBlockSubtitle cardBlockSubtitle__indicator">
            {subtitle}
          </span>
        )}
        {isCollapsed && (
          <button className="button" onClick={() => setCollapse(!collapse)}>
            {collapse ? 'Expandir' : 'Colapsar'}
          </button>
        )}
      </div>
      {secondTitle && (
        <div className="cardBlockHeader">
          <h2 className="cardBlockTitle">
            {secondTitle}
            <span className="cardBlockTitleSecondary">{secondTitleValue}</span>
          </h2>
        </div>
      )}

      <div className={`cardBlockContent ${collapse && `collapse`}`}>
        {children}
      </div>
    </div>
  );
};

Card.propTypes = {
  title: PropTypes.string.isRequired,
  titleValue: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

Card.defaultProps = {
  titleValue: null,
  subtitle: null
};

export default Card;
